import {
  IPrintBehaviorSpecifiable, instanceOfIPrintBehaviorSpecifiable,
  IEditBehaviorSpecifiable, instanceOfIEditBehaviorSpecifiable,
  IPageExtendBehaviorSpecifiable, instanceOfIPageExtendBehaviorSpecifiable,
  IInputMethodBehaviorSpecifiable, instanceOfIInputMethodBehaviorSpecifiable,
  ITurnedTextStyleSpecifiable, instanceOfITurnedTextStyleSpecifiable,
  IScriptTableBehaviorSpecifiable, instanceOfIScriptTableBehaviorSpecifiable,
} from "../../../../documaker/domain/format/objects";
import { IStandardTextDrawableObject, instanceOfIStandardTextDrawableObject } from "./IStandardTextDrawableObject";

export interface IScriptObject extends
IStandardTextDrawableObject,
IPrintBehaviorSpecifiable,
IEditBehaviorSpecifiable,
IPageExtendBehaviorSpecifiable,
IInputMethodBehaviorSpecifiable,
ITurnedTextStyleSpecifiable,
IScriptTableBehaviorSpecifiable {
}

export function instanceOfIScriptObject(instance: any): instance is IScriptObject {
  return instance
      && instanceOfIPrintBehaviorSpecifiable(instance)
      && instanceOfIEditBehaviorSpecifiable(instance)
      && instanceOfIPageExtendBehaviorSpecifiable(instance)
      && instanceOfIInputMethodBehaviorSpecifiable(instance)
      && instanceOfITurnedTextStyleSpecifiable(instance)
      && instanceOfIScriptTableBehaviorSpecifiable(instance)
      && instanceOfIStandardTextDrawableObject<IScriptObject>(instance, "script");
}
